import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MasterProductCounterEditPage } from './master-product-counter-edit.page';

const routes: Routes = [
  {
    path: '',
    component: MasterProductCounterEditPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MasterProductCounterEditPageRoutingModule {}
